module.exports = __webpack_public_path__ + "img/back_items-sprite-1x.619fc9fc.png";